import { useMemo } from "react";
import { getContrastText } from "@babackapp/ui/lib/colors";
import type { EmailsThemeDto } from "@babackapp/private-api-client/types";

/**
 * Hook to determine the appropriate social icon color based on theme and section
 */
export function useSocialIconColor(
  theme: EmailsThemeDto | null | undefined,
  section: "before" | "inside" | "after"
): 'black' | 'white' {
  const backgroundColor = useMemo(() => {
    if (!theme) return '#ffffff';

    if (section === 'inside') {
      return theme.cardColor || '#ffffff';
    } else {
      return theme.backgroundColor || '#ffffff';
    }
  }, [theme, section]);

  const iconColor = useMemo(() => {
    try {
      const contrastText = getContrastText(backgroundColor);
      return contrastText === '#fff' ? 'white' : 'black';
    } catch (error) {
      return 'black';
    }
  }, [backgroundColor]);

  return iconColor;
}
